// extracted by mini-css-extract-plugin
export default {"link-container":"styles_link-container__cXPQx","link":"styles_link__sVQiR","active":"styles_active__gMfb+"};